<div class="container_width flex flex-column gap-5 flex-1">
  <div class="flex align-items-center justify-content-between">
    <h1 class="font-semibold text-2xl">My Colleges</h1>
  </div>

  <!-- Already saved institutes -->
  <div class="flex flex-column gap-3">
    <app-institute-item *ngFor="let item of myInstitutes; let i = index" [item]="item"
      (myInstituteEmitter)="toggleMyInstitute($event, true, i)" [loading]="loadingInstituteId === item.id"
      [isInstituteSaved]="true">
    </app-institute-item>
  </div>

  <!-- Random institutes shown when no saved institutes -->
  <div *ngIf="myInstitutes && myInstitutes.length == 0" class="flex flex-column gap-3">
    <app-institute-search-item *ngFor="let item of randomInstitutes; let i = index" [item]="item" [portal]="'student'"
      (myInstituteEmitter)="toggleMyRandomInstitute($event, !!item.isMyInstitute, i)"
      [loading]="loadingInstituteId === item.id" [isInstituteSaved]="!!item.isMyInstitute">
    </app-institute-search-item>
  </div>
</div>